import { faCircleCheck, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const DeletedRenderer = (props) => {

    switch (props.value) {
        case true:
          return <FontAwesomeIcon icon={faCircleXmark} style={{ color: "#e85454", height: '20px' }} />;
        case false:
          return <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#a5c946", height: '20px' }} />;
        default:
            return (<span>{props.value}</span>);
    }

}

export default DeletedRenderer;